<div class="c-modal__inner">
  <form (ngSubmit)="onSubmit(true)" [formGroup]="form" class="c-modal__form c-form c-form--d">
    <div class="c-modal__head">
      <div class="row">
        <div class="c-modal__close" (click)="close()">
          <p500-ui-icon name="controls-close"></p500-ui-icon>
        </div>
        <div class="c-modal__title col-12" i18n="@@common.edit_2fa">Edit 2FA</div>
        <div class="c-modal__subtitle col-12" i18n="@@common.extra_layer_of_security">Extra layer of security</div>
      </div>
    </div>

    <div *ngIf="!isLoading; else preloader" class="c-modal__body">
      <ng-container *ngIf="addTelegram; else telegramTmpl">
        <div class="c-modal__description d-flex mb-14">
          <div class="--information mr-10">
            <p500-ui-icon name="information"></p500-ui-icon>
          </div>
          <div>
            <ng-container i18n="@@common.2fa_whoam_hint">
              To receive the TelegramID code, you need to write the command <b>"/whoami"</b> (without quotes) in messages to the Telegram
              bot
            </ng-container>
            <span class="text-color--primary">&#64;irev_com_bot</span>
          </div>
        </div>
        <div class="mb-14">
          <p500-ui-number-field label="Telegram ID" [formControl]="telegram" [disabled]="validateToken"></p500-ui-number-field>
        </div>
        <ng-container *ngIf="validateToken" [ngTemplateOutlet]="validationCodeTmpl"></ng-container>
        <div class="mb-14 telegram-verify" *ngIf="!validateToken">
          <div class="c-modal__action">
            <button
              type="submit"
              p500-ui-button
              i18n="@@common.verify"
              [disabled]="!telegram.value"
              (click)="verifyTelegramId(); $event.preventDefault()"
            >
              Verify
            </button>
          </div>
        </div>
        <div class="mb-14 telegram-verify" *ngIf="validateToken">
          <div class="c-modal__action">
            <button
              type="submit"
              p500-ui-button
              [stroked]="true"
              i18n="@@common.back"
              (click)="returnToTelegramId(); $event.preventDefault()"
            >
              Back
            </button>
          </div>
          <ng-container [ngTemplateOutlet]="submitCodeButtons"></ng-container>
        </div>
      </ng-container>
      <div class="mb-20">
        <p500-ui-boolean-select-field label="2FA" [formControl]="otp" (ngModelChange)="handleChange($event)"></p500-ui-boolean-select-field>
      </div>
      <ng-container *ngIf="validateToken2fa">
        <ng-container [ngTemplateOutlet]="validationCodeTmpl"></ng-container>
        <div class="mb-14 telegram-verify">
          <ng-container [ngTemplateOutlet]="submitCodeButtons"></ng-container>
        </div>
      </ng-container>
    </div>

    <div class="c-modal__footer">
      <div class="d-flex">
        <div class="c-modal__action" (click)="close(); $event.preventDefault()">
          <button type="button" p500-ui-button stroked="true" i18n="@@common.cancel">Cancel</button>
        </div>
        <div class="c-modal__action">
          <button
            type="submit"
            p500-ui-button
            classIcon="p500-ui-icon-check"
            positionIcon="right"
            i18n="@@common.save"
            [disabled]="submitButtonDisabled()"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  </form>
</div>

<ng-template #preloader>
  <p500-ui-cube-preloader></p500-ui-cube-preloader>
</ng-template>

<ng-template #telegramTmpl>
  <div class="c-modal__telegram-id">
    <span class="label">Telegram ID:</span>
    <span class="value">
      <gtd-ui-field-default-string-or-empty [data]="telegram.value"></gtd-ui-field-default-string-or-empty>
    </span>
    <button
      class="ml-8"
      p500-ui-circled-button
      size="small"
      color="primary"
      [transparent]="true"
      (click)="editTelegram(); $event.preventDefault()"
    >
      <p500-ui-icon [name]="'buttons-pencil'"></p500-ui-icon>
    </button>
  </div>
</ng-template>

<ng-template #validationCodeTmpl>
  <div class="mb-14">
    <p500-ui-text-field label="2FA Code" [formControl]="validationCode"></p500-ui-text-field>
    <span *ngIf="validationCode.invalid" class="text-color--red" i18n="@@common.incorrect_code">Incorrect code</span>
  </div>
</ng-template>

<ng-template #submitCodeButtons>
  <div class="c-modal__action">
    <button
      type="submit"
      p500-ui-button
      i18n="@@common.send_new_code"
      [stroked]="true"
      (click)="verifyTelegramId(true); $event.preventDefault()"
    >
      Send New Code
    </button>
  </div>
  <div class="c-modal__action">
    <button
      type="submit"
      p500-ui-button
      classIcon="p500-ui-icon-check"
      positionIcon="right"
      i18n="@@common.submit"
      (click)="verifyTelegramId(); $event.preventDefault()"
      [disabled]="isLoading || !validationCode.value || validationCode.invalid"
    >
      Submit
    </button>
  </div>
</ng-template>
